// Add your custom JS here.
( function( $ ) {



    // Fade in effects
    AOS.init();
    


    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300
    });



    // check if page is scrolled from the top for header
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('#wrapper-navbar').addClass('off-top');

        }
        if($(this).scrollTop() < 50)
        {   
            $('#wrapper-navbar').removeClass('off-top');
        }
    });



    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('#wrapper-navbar').addClass('hide');
        } else {
            $('#wrapper-navbar').removeClass('hide');
        }
        lastScrollTop = st;
    });



    // other sites toggle
    $(document).on("click", function(e) {
        if ($(e.target).is(".othersites .toggle")) {
            $(e.target).parent().addClass('active');
        } 

        else {
            $(".othersites").removeClass("active");
        }
    });

    

    // mobile menu toggle
    $(".mobile-icon").on("click", function () {
        $('#wrapper-navbar').toggleClass('menu-open');
    });



    // home fold video popup
    $(".page-template-frontpage .section-one .button").on("click", function () {
        $('.video-popup').addClass('active');
    });



    // Home gallery swiper
    var swiper = new Swiper(".homegallery-swiper", {
        spaceBetween: 50,
        grabCursor: true,
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [0, 0, -400],
            },
            next: {
                translate: ["100%", 0, 0],
            },
        },

        navigation: {
            nextEl: ".homegallery-next",
            prevEl: ".homegallery-prev",
        },
    });



    // news swiper
    if ($(window).width() < 992) {

        $('.news-section .article').addClass('swiper-slide');
        $('.news-section .article').wrapAll('<div class="news-swiper swiper"><div class="swiper-wrapper"></div></div>');
        $('.news-section .articles').append('<div class="news-navigation slider-navigation pink"><div class="news-prev"></div><div class="news-next"></div></div>');

        var swiper = new Swiper(".news-swiper", {
            spaceBetween: 20,
            grabCursor: true,

            navigation: {
                nextEl: ".news-next",
                prevEl: ".news-prev",
            },
        });
    }



    // Swiper example
    var swiper = new Swiper(".cards-swiper", {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        grabCursor: true,

        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },

        navigation: {
            nextEl: ".cards-next",
            prevEl: ".cards-prev",
        },
    });

    // Swiper example
    var swiper = new Swiper(".noloopcards-swiper", {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        grabCursor: true,

        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },

        navigation: {
            nextEl: ".noloopcards-next",
            prevEl: ".noloopcards-prev",
        },
    });



    // points swiper
    if ($(window).width() < 992) {

        $('.page-template-about-us .points .point').wrapAll('<div class="points-swiper swiper"><div class="swiper-wrapper"></div></div>');

        $('.page-template-about-us .points').append('<div class="points-navigation slider-navigation white"><div class="points-prev"></div><div class="points-next"></div></div>');


        var divs = $(".page-template-about-us .swiper-wrapper .point");
        for(var i = 0; i < divs.length; i+=3) {
            divs.slice(i, i+3).wrapAll("<div class='swiper-slide'></div>");
        }

        var swiper = new Swiper(".page-template-about-us .points-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            grabCursor: true,

            navigation: {
                nextEl: ".points-next",
                prevEl: ".points-prev",
            },
        });
    }



    // team swiper
    if ($(window).width() < 992) {

        $('.team .article').addClass('swiper-slide');
        $('.team .article').wrapAll('<div class="team-swiper swiper"><div class="swiper-wrapper"></div></div>');
        $('.team').append('<div class="team-navigation slider-navigation pink"><div class="team-prev"></div><div class="team-next"></div></div>');

        var swiper = new Swiper(".team-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            grabCursor: true,

            navigation: {
                nextEl: ".team-next",
                prevEl: ".team-prev",
            },
        });
    }



    // careers swiper
    if ($(window).width() < 992) {

        $('.section-seven .career').addClass('swiper-slide');
        $('.section-seven .career').wrapAll('<div class="career-swiper swiper"><div class="swiper-wrapper"></div></div>');
        $('.section-seven .careers').append('<div class="career-navigation slider-navigation lightgreen"><div class="career-prev"></div><div class="career-next"></div></div>');

        var swiper = new Swiper(".career-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            grabCursor: true,

            navigation: {
                nextEl: ".career-next",
                prevEl: ".career-prev",
            },
        });
    }



    // expertises swiper
    var swiper = new Swiper(".expertises-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: false,
        grabCursor: true,

        navigation: {
            nextEl: ".expertises-next",
            prevEl: ".expertises-prev",
        },
    });



    // partners swiper
    var swiper = new Swiper(".partners-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: false,
        grabCursor: true,

        navigation: {
            nextEl: ".partners-next",
            prevEl: ".partners-prev",
        },
    });



    // fullwidth swiper
    var swiper = new Swiper(".fullwidth-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        grabCursor: true,

        navigation: {
            nextEl: ".fullwidth-next",
            prevEl: ".fullwidth-prev",
        },
    });



    // career quotes swiper
    var swiper = new Swiper(".quotes-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        grabCursor: true,
        effect: 'fade',

        navigation: {
            nextEl: ".quotes-next",
            prevEl: ".quotes-prev",
        },
    });



    // setup marquee variables
    var toplogoQuantity = $(".logos .logo-bar-top .logo").length;
    var bottomlogoQuantity = $(".logos .logo-bar-bottom .logo").length;
    var windowWidth = $(window).width();
    if ($(window).width() < 992) {
        var boxWidth = windowWidth / 3;
    }

     else {
        var boxWidth = windowWidth / 5;
    }
    var topmarqueeWidth = boxWidth * toplogoQuantity;
    var bottommarqueeWidth = boxWidth * bottomlogoQuantity;



    //initially each box position
    gsap.set(".logos .logo", {
        x: (i) => i * boxWidth
    });



    // marquee to right
    gsap.to(".logos .logo-bar-top .logo", {
        duration: 80,
        ease: "none",
        x: "+=" + topmarqueeWidth, //move each box 140vw to right
        modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % topmarqueeWidth) //force x value to be between 0 and 140vw using modulus
        },
        repeat: -1
    });



    // marquee to left
    gsap.to(".logos .logo-bar-bottom .logo", {
        duration: 80,
        ease: "none",
        x: "-=" + bottommarqueeWidth, //move each box 140vw to right
        modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % bottommarqueeWidth) //force x value to be between 0 and 140vw using modulus
        },
        repeat: -1
    });



    // popup video toggle
    $(".page-template-realisations .section-four .swiper-slide, .swiper-slide.video").on("click", function () {
        var videopopup = $(this).attr('video');
        $('#' + videopopup).addClass('active');
    });



    // popup close video toggle
    $(".video-popup").on("click", function () {
        $(this).removeClass('active');

        var video = $(this).children('iframe').attr("src");
        $(this).children('iframe').attr("src","");
        $(this).children('iframe').attr("src",video);
    });



    // filter toggles
    $(document).on("click", function(e) {
        if ($(e.target).is(".filter-option h4")) {
            // $(e.target).parent().addClass('active');

            if ($(e.target).parent().hasClass('active')) {
                $(e.target).parent().removeClass('active');
            } else {
                $('.filter-option').removeClass('active');
                $(e.target).parent().addClass('active');
            }
        } 

        else {
            $(".filter-option").removeClass("active");
        }
    });



    // contact office toggle
    $('.page-template-contact #office-1, .page-template-contact .office-tab:first-child').addClass('active');

    $(".office-tab, .office-pin").on("click", function () {
        var office = $(this).attr('office');
        $('.office-tab, .office').removeClass('active');
        $('.office-tab[office="' + office + '"]').addClass('active');
        $(this).addClass('active');
        $('#office-' + office).addClass('active');
    });



    // glossary functions
    var obj = {};
    $('.words').children().each(function () {
        $.each(($(this).attr('letter') || '').split(/\s+/), function (i, v) {
            obj[v] = true;
        })
    })
    var classes = $.map(obj, function (val, key) {
        return key == '' ? undefined : key;
    });

    classes.forEach(function(towrap) {

        $(".glossaire-nav span").each(function( index ) {
            if ($(this).html() == towrap) {
                $(this).replaceWith('<a class="navletter-' + towrap + '" href=#' + towrap + '>' + towrap + '</a>');
            }
        });

        $("." + towrap).each(function(){
            $(this).not("." + towrap + "+." + towrap).each(function(){
                $(this).nextUntil(":not(." + towrap + ")").addBack().wrapAll('<div wrapletter="' + towrap + '" class="wrap-letter"></div>');
            });
        });
    });

    // page sub menu's
    $('.glossaire-nav a:first-child').addClass('active');
    $(window).on('scroll', function() {
        $(".letteranchor").each(function() {
            if ($(window).scrollTop() >= $(this).offset().top - window.innerHeight / 2) {
                var currentItem = $(this).attr('id');
                $('.glossaire-nav a').removeClass('active');
                $('.navletter-' + currentItem).addClass('active');
            }
        });
    });




    $('.wrap-letter').each(function() {
        var wrapletter = $(this).attr('wrapletter');

        $(this).prepend('<span>' + wrapletter + '</span>');
        $(this).prepend('<div id="' + wrapletter + '" class="letteranchor"></div>');
    });



    // reset filters
    $(".view-all").on("click", function () {
        $('input').prop('checked', false);
        $('input').change();
    });



    if ($('body').hasClass('single-post')) {
       $('.menu-item-32').addClass('current-menu-item'); 
    }

    if ($('body').hasClass('single-carrieres')) {
        $('.menu-item-33').addClass('current-menu-item'); 
    }

    if ($('body').hasClass('single-fiche-offre')) {
        $('.menu-item-33').addClass('current-menu-item'); 
    }

    if ($('body').hasClass('single-projet')) {
        $('.menu-item-38').addClass('current-menu-item'); 
    }



    // make fullscreen vimeo popup if button contains vimeo iframe link
    $('.button[href*="player.vimeo"').each(function() {
        $(this).addClass('hasvimeo');
        var Index = $(this).index();
        var videoLink = $(this).attr('href');
        var buttonTex = $(this).text();
        $('<div class="vimeopopupvideo button-video-popup video-popup-' + Index + '"><div class="close"></div><iframe src="' + videoLink + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>').insertAfter('.fold, .fold-inverted');
        $(this).replaceWith('<span class="button button-' + Index + ' darkgreen hasvimeo">' + buttonTex + '</span>');
    });

    // open vimeo popup videos
    $(".hasvimeo").on("click", function () {
        var buttonid = $(this).index();
        $('.video-popup-' + buttonid + '').addClass('active');
    });

    // close vimeo popup videos
    $(".vimeopopupvideo").on("click", function () {
        $(this).removeClass('active');
        var iframe = $(this).children("iframe")[0].contentWindow;
        iframe.postMessage('{"method":"pause"}', '*');
    });






    // make fullscreen youtube popup if button contains youtube iframe link
    $('.button[href*="youtube.com/embed"').each(function() {
        $(this).addClass('hasyoutube');
        var Index = $(this).index();
        var videoLink = $(this).attr('href');
        var buttonTex = $(this).text();
        $('<div class="youtubepopupvideo button-video-popup video-popup-' + Index + '"><div class="close"></div><iframe width="560" height="315" src="' + videoLink + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>').insertAfter('.fold, .fold-inverted');
        $(this).replaceWith('<span class="button button-' + Index + ' darkgreen hasyoutube">' + buttonTex + '</span>');
    });

    // open youtube popup videos
    $(".hasyoutube").on("click", function () {
        var buttonid = $(this).index();
        $('.video-popup-' + buttonid + '').addClass('active');
    });

    // close youtube popup videos
    $(".youtubepopupvideo").on("click", function () {
        $(this).removeClass('active');
        
        var video = $(this).children('iframe').attr("src");
        $(this).children('iframe').attr("src","");
        $(this).children('iframe').attr("src",video);

    });

    $('.articles-overview .filter-options .filter-option:first-child h4').text('Catégorie');

} )( jQuery );